// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.material-design-icon {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
@media only screen and (max-width: 512px) {
  .dialog__modal .modal-wrapper--small .modal-container {
    width: fit-content;
    height: unset;
    max-height: 90%;
    position: relative;
    top: unset;
    border-radius: var(--border-radius-large);
  }
}
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-40a87f52] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.dialog[data-v-40a87f52] {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
}
.dialog__modal[data-v-40a87f52] .modal-wrapper .modal-container {
  display: flex !important;
  padding-block: 4px 0;
  padding-inline: 12px 0;
}
.dialog__modal[data-v-40a87f52] .modal-wrapper .modal-container__content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dialog__wrapper[data-v-40a87f52] {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.dialog__wrapper--collapsed[data-v-40a87f52] {
  flex-direction: column;
}
.dialog__navigation[data-v-40a87f52] {
  display: flex;
  flex-shrink: 0;
}
.dialog__wrapper:not(.dialog__wrapper--collapsed) .dialog__navigation[data-v-40a87f52] {
  flex-direction: column;
  overflow: hidden auto;
  height: 100%;
  min-width: 200px;
  margin-inline-end: 20px;
}
.dialog__wrapper.dialog__wrapper--collapsed .dialog__navigation[data-v-40a87f52] {
  flex-direction: row;
  justify-content: space-between;
  overflow: auto hidden;
  width: 100%;
  min-width: 100%;
}
.dialog__name[data-v-40a87f52] {
  text-align: center;
  height: fit-content;
  min-height: var(--default-clickable-area);
  line-height: var(--default-clickable-area);
  overflow-wrap: break-word;
  margin-block-end: 12px;
}
.dialog__content[data-v-40a87f52] {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding-inline-end: 12px;
}
.dialog__text[data-v-40a87f52] {
  padding-block-end: 6px;
}
.dialog__actions[data-v-40a87f52] {
  display: flex;
  gap: 6px;
  align-content: center;
  width: fit-content;
  margin-inline: auto 12px;
  margin-block: 0;
}
.dialog__actions[data-v-40a87f52]:not(:empty) {
  margin-block: 6px 12px;
}
@media only screen and (max-width: 512px) {
  .dialog__name[data-v-40a87f52] {
    text-align: start;
    margin-inline-end: var(--default-clickable-area);
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcDialog-M36tj7nk.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,yCAAyC;EAC3C;AACF;AACA;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,aAAa;EACb,cAAc;EACd,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,iBAAiB;IACjB,gDAAgD;EAClD;AACF","sourcesContent":["@charset \"UTF-8\";\n.material-design-icon {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n@media only screen and (max-width: 512px) {\n  .dialog__modal .modal-wrapper--small .modal-container {\n    width: fit-content;\n    height: unset;\n    max-height: 90%;\n    position: relative;\n    top: unset;\n    border-radius: var(--border-radius-large);\n  }\n}\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-40a87f52] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.dialog[data-v-40a87f52] {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.dialog__modal[data-v-40a87f52] .modal-wrapper .modal-container {\n  display: flex !important;\n  padding-block: 4px 0;\n  padding-inline: 12px 0;\n}\n.dialog__modal[data-v-40a87f52] .modal-wrapper .modal-container__content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.dialog__wrapper[data-v-40a87f52] {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n.dialog__wrapper--collapsed[data-v-40a87f52] {\n  flex-direction: column;\n}\n.dialog__navigation[data-v-40a87f52] {\n  display: flex;\n  flex-shrink: 0;\n}\n.dialog__wrapper:not(.dialog__wrapper--collapsed) .dialog__navigation[data-v-40a87f52] {\n  flex-direction: column;\n  overflow: hidden auto;\n  height: 100%;\n  min-width: 200px;\n  margin-inline-end: 20px;\n}\n.dialog__wrapper.dialog__wrapper--collapsed .dialog__navigation[data-v-40a87f52] {\n  flex-direction: row;\n  justify-content: space-between;\n  overflow: auto hidden;\n  width: 100%;\n  min-width: 100%;\n}\n.dialog__name[data-v-40a87f52] {\n  text-align: center;\n  height: fit-content;\n  min-height: var(--default-clickable-area);\n  line-height: var(--default-clickable-area);\n  overflow-wrap: break-word;\n  margin-block-end: 12px;\n}\n.dialog__content[data-v-40a87f52] {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding-inline-end: 12px;\n}\n.dialog__text[data-v-40a87f52] {\n  padding-block-end: 6px;\n}\n.dialog__actions[data-v-40a87f52] {\n  display: flex;\n  gap: 6px;\n  align-content: center;\n  width: fit-content;\n  margin-inline: auto 12px;\n  margin-block: 0;\n}\n.dialog__actions[data-v-40a87f52]:not(:empty) {\n  margin-block: 6px 12px;\n}\n@media only screen and (max-width: 512px) {\n  .dialog__name[data-v-40a87f52] {\n    text-align: start;\n    margin-inline-end: var(--default-clickable-area);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
